export * from './autorisation-bnbaccess.model';
export * from './autorisation-bnbaccess-popup.service';
export * from './autorisation-bnbaccess.service';
export * from './autorisation-bnbaccess-dialog.component';
export * from './autorisation-bnbaccess-delete-dialog.component';
export * from './autorisation-bnbaccess-detail.component';
export * from './autorisation-bnbaccess.component';
export * from './autorisation-bnbaccess.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/index.ts